var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8VerifiedAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-verified-account",
    d: "M24,4a7.424,7.424,0,0,0-6.541,4.023,7.321,7.321,0,0,0-9.434,9.434,7.329,7.329,0,0,0,0,13.084,7.321,7.321,0,0,0,9.434,9.434,7.329,7.329,0,0,0,13.084,0,7.321,7.321,0,0,0,9.434-9.434,7.329,7.329,0,0,0,0-13.084,7.321,7.321,0,0,0-9.434-9.434A7.426,7.426,0,0,0,24,4Zm0,3a4.486,4.486,0,0,1,4.34,3.332,1.5,1.5,0,0,0,2.254.875,4.49,4.49,0,0,1,6.2,6.2,1.5,1.5,0,0,0,.877,2.254,4.493,4.493,0,0,1,0,8.68,1.5,1.5,0,0,0-.875,2.254,4.49,4.49,0,0,1-6.2,6.2,1.5,1.5,0,0,0-2.254.877,4.493,4.493,0,0,1-8.68,0,1.5,1.5,0,0,0-2.254-.875,4.49,4.49,0,0,1-6.2-6.2,1.5,1.5,0,0,0-.877-2.254,4.493,4.493,0,0,1,0-8.68,1.5,1.5,0,0,0,.875-2.254,4.49,4.49,0,0,1,6.2-6.2,1.5,1.5,0,0,0,2.254-.877A4.486,4.486,0,0,1,24,7Zm7.471,10.986a1.5,1.5,0,0,0-1.031.453L21.5,27.379l-3.939-3.939a1.5,1.5,0,1,0-2.121,2.121l5,5a1.5,1.5,0,0,0,2.121,0l10-10a1.5,1.5,0,0,0-1.09-2.574Z",
    transform: "translate(-4 -4)",
    fill: "#6e6e72"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8VerifiedAccount);
export default __webpack_public_path__ + "static/media/icons8-verified-account.48483481.svg";
export { ForwardRef as ReactComponent };